"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateModuleResolutionsOutputDtoSchema = exports.updateModuleResolutionsInputDtoSchema = exports.updateModuleResolutionItemDtoSchema = void 0;
const z = __importStar(require("zod"));
const hil_module_resolution_js_1 = require("../../types/hil-module-resolution.js");
exports.updateModuleResolutionItemDtoSchema = z
    .object({
    id: z.string().optional(),
    moduleRef: z.string().optional(),
    data: hil_module_resolution_js_1.HilModuleResolution.dtoSchema,
})
    .refine((item) => (item.id === undefined) !== (item.moduleRef === undefined), {
    message: 'Exactly one of id or moduleRef must be provided.',
});
exports.updateModuleResolutionsInputDtoSchema = z
    .object({
    projectId: z.string().optional(),
    buildId: z.string().optional(),
    moduleResolutions: exports.updateModuleResolutionItemDtoSchema.array(),
})
    .refine((input) => !input.moduleResolutions.some((item) => item.moduleRef !== undefined) ||
    (input.projectId !== undefined && input.buildId !== undefined), {
    message: 'projectId and buildId are required when an item is addressed by moduleRef.',
});
exports.updateModuleResolutionsOutputDtoSchema = z.object({
    moduleResolutions: hil_module_resolution_js_1.HilModuleResolution.schema.array(),
});
//# sourceMappingURL=update-module-resolutions.js.map